import typeforce from '@exodus/typeforce';
import lodash from 'lodash';
import { createSelector } from 'reselect';
import { MY_STATE } from './constants.js';
const { identity } = lodash;
const OPTIONAL_SELECTOR_FALLBACK = () => { };
Object.defineProperty(OPTIONAL_SELECTOR_FALLBACK, 'isFallback', {
    value: true,
    writable: false,
});
const createSelectorFromDependencies = (dependencies, resultFunction) => {
    return createSelector(...dependencies, resultFunction);
};
const expandSelectorDependencyId = ({ moduleId, dependency, }) => {
    typeforce({
        module: (value) => value == null || (typeof value === 'string' && !value.includes('.')),
        selector: 'String',
        optional: '?Boolean',
    }, dependency, true);
    return `${dependency.module || moduleId}.selectors.${dependency.selector}${dependency.optional ? '?' : ''}`;
};
const generateSelectorDependencies = ({ id: moduleId, initialState, selectorDefinitions = [], createLogger, }) => {
    const moduleSelectorDependencies = selectorDefinitions.map((selectorDefinition) => {
        const dependencies = (selectorDefinition.dependencies || []).map((dependency) => expandSelectorDependencyId({ moduleId, dependency }));
        return {
            id: `${moduleId}.selectors.${selectorDefinition.id}`,
            type: 'selector',
            dependencies,
            factory: (...deps) => {
                const mappedDeps = deps.map((dep) => (dep ? dep : OPTIONAL_SELECTOR_FALLBACK));
                if ('resultFunction' in selectorDefinition) {
                    return createSelectorFromDependencies(mappedDeps, selectorDefinition.resultFunction);
                }
                return selectorDefinition.selectorFactory(...mappedDeps);
            },
        };
    });
    const selfStateSelector = createSelector((state) => state[moduleId] || initialState, identity);
    moduleSelectorDependencies.push({
        id: `${moduleId}.selectors.${MY_STATE}`,
        type: 'selector',
        factory: () => selfStateSelector,
    }, {
        id: `${moduleId}.selectors.logger`,
        type: 'selector',
        factory: () => () => createLogger(`exodus:${moduleId}:redux`),
    });
    const moduleSelectorDependenciesIds = moduleSelectorDependencies.map(({ id }) => id);
    moduleSelectorDependencies.push({
        id: `${moduleId}.selectors`,
        dependencies: moduleSelectorDependenciesIds,
        type: 'selectors',
        factory: (...dependencies) => {
            const selectors = Object.create(null);
            selectorDefinitions.forEach(({ id }, i) => {
                if (id !== MY_STATE) {
                    selectors[id] = dependencies[i];
                }
            });
            return selectors;
        },
    });
    return moduleSelectorDependencies;
};
export default generateSelectorDependencies;
